import { render } from "./LoyaltyCommunicationSettings.vue?vue&type=template&id=2915d900&scoped=true"
import script from "./LoyaltyCommunicationSettings.vue?vue&type=script&lang=js"
export * from "./LoyaltyCommunicationSettings.vue?vue&type=script&lang=js"

import "./LoyaltyCommunicationSettings.vue?vue&type=style&index=0&id=2915d900&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2915d900"]])

export default __exports__